/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum VestingTermLeaverProvisionType {
    GOOD_LEAVER = 'GOOD_LEAVER',
    INTERMEDIATE_LEAVER = 'INTERMEDIATE_LEAVER',
    BAD_LEAVER = 'BAD_LEAVER',
}
